<template>
  <div>
    <v-tabs v-model="tab" centered>
      <v-tab
        v-for="(item, index) in menuLinks"
        :key="index"
        @click="$router.push({ name: item.name })"
      >{{ $t(`menuHeaders.${item.name}`)}}</v-tab>
    </v-tabs>
    <router-view
      @add-application="handleAddApplicationFromMilestones"
      :payment-applications="applications"
      :payment-milestones="milestones"
      :contract="contract"
      :base-currency="contract.baseCurrency"
      @milestones-update="fetchMilestones"
      @applications-update="fetchApplications"
      @application-modal="handleCreateOrEditApplication"
    />
  </div>
</template>

<script>
import {
  getPaymentApplications,
  getPaymentMilestones,
  addPaymentApplication,
  prepareMilestoneApplicationsItems,
  updatePaymentApplication
} from '@/services'

export default {
  name: 'PaymentsView',
  props: {
    contract: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      menuLinks: this.$router.options.routes
        .find(i => i.name === 'contractMain').children
        .find(i => i.name === 'payments').children,
      tab: 0,
      milestones: [],
      applications: []
    }
  },
  async created () {
    this.setRoute()
    if (this.contract.id) {
      await this.fetchApplications(this.$route.params.contractId)
      await this.fetchMilestones()
    }
  },
  updated () {
    this.setRoute()
  },
  methods: {
    async createOrUpdatePaymentApplication (data) {
      data.id
        ? await updatePaymentApplication(data)
        : await addPaymentApplication(this.$route.params.contractId, data)
      await this.fetchApplications(this.$route.params.contractId)
      await this.fetchMilestones()
    },
    handleCreateOrEditApplication (payment) {
      this.openApplicationModal(payment)
    },
    handleAddApplicationFromMilestones (paymentMilestones) {
      this.$router.push({ name: 'applications', params: { contractId: this.$route.params.contractId } })
      this.tab = 1
      this.openApplicationModal({ paymentMilestones })
    },
    openApplicationModal (payment) {
      this.$eventBus.$emit('OPEN_MODAL', {
        component: 'PaymentApplicationForm',
        options: { maxWidth: 950 },
        scope: {
          title: payment && payment.id ? this.$t('payment.application.edit') : this.$t('payment.application.add'),
          payment,
          workflows: this.contract.workflows,
          baseCurrency: this.contract.currencies.find(i => i.value === 1),
          chosenCurrency: this.contract.chosenCurrency,
          currencies: this.contract.currencies,
          paymentApplications: this.applications,
          rawMilestones: this.milestones,
          processedMilestones: prepareMilestoneApplicationsItems(this.milestones, this.applications, this.contract.currencies)
        },
        handlers: {
          savePayment: this.createOrUpdatePaymentApplication
        }
      })
    },
    async fetchMilestones () {
      this.milestones = await getPaymentMilestones(this.applications, this.contract)
    },
    async fetchApplications () {
      this.applications = await getPaymentApplications(this.contract)
    },
    setRoute () {
      this.$route.name === 'payments' && this.$router.replace({ name: 'schedule' })
      this.tab = this.menuLinks.findIndex(i => i.name === this.$route.name)
    }
  },
  watch: {
    async 'contract.id' () {
      await this.fetchApplications(this.$route.params.contractId)
      await this.fetchMilestones()
    }
  }
}
</script>
